module.exports = __webpack_public_path__ + "img/business_2_1.d311c8c1.png";